import { useEffect } from 'react';
import useEditorStore from './EditorStore';
export const CHANNEL = 'xiasbio-editor';
const EditorPreview = () => {
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.source === window || event.data?.channel !== CHANNEL)
                return;
            const { type, data } = event.data;
            if (type === 'editor-update') {
                console.log('Received editor data', data);
                useEditorStore.getState().setEditCurve(data);
            }
        };
        window.addEventListener('message', handleMessage);
        window.addEventListener('beforeunload', onClose);
        return () => {
            window.removeEventListener('beforeunload', onClose);
            window.removeEventListener('message', handleMessage);
        };
    }, []);
    const onClose = () => {
        window.opener?.postMessage({ channel: CHANNEL, type: 'close' }, '*');
    };
    return null;
};
export default EditorPreview;
